// extracted by mini-css-extract-plugin
export default {"wrap":"WhyChoose_wrap__Cd4ab","col_01":"WhyChoose_col_01__LNHWq","col_02":"WhyChoose_col_02__QAFQM","content":"WhyChoose_content__BHDLr","contact":"WhyChoose_contact__+giOo"};